import React from 'react';
import Form from '../common/masterform/Form';
import formConfig from './formConfig';

export default function SalesOrdersOverview() {
    return <Form formId="sales-orders" config={formConfig}/>
}

